<template>
  <div>
    <el-card>
      <div id="app" v-cloak>
        <div>
          <!-- <el-menu :default-active="activeIndex" class="el-menu-demo" @select="handleSelect">
                <el-menu-item index="1">文字短信</el-menu-item>
                <el-menu-item index="2">视频短信</el-menu-item>
            </el-menu> -->
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">文字短信</el-menu-item>
            <el-menu-item index="2">视频短信</el-menu-item>
          </el-menu>
        </div>
        <div class="ibox-content">
          <div v-if="activeIndex == 1">
            <div style="margin-bottom: 8px">
              <el-button size="small" @click="addwzClick" type="primary">添加模板</el-button>
            </div>
            <el-tabs v-model="activeName" type="card" @tab-click="handleClicks">
              <el-tab-pane label="全部" name="0"></el-tab-pane>
              <el-tab-pane label="待审核" name="1"></el-tab-pane>
              <el-tab-pane label="已通过" name="2"></el-tab-pane>
              <el-tab-pane label="已驳回" name="3"></el-tab-pane>
            </el-tabs>
            <div class="ibox-content">
              <el-table :data="tableData" border style="width: 100%" v-loading="loadings" :height="heights"
                ref="configurationTable">
                <el-table-column prop="id" label="模板ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="type_text" label="短信类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sign_text" label="签名" show-overflow-tooltip></el-table-column>
                <el-table-column prop="title" label="标题" show-overflow-tooltip></el-table-column>
                <el-table-column prop="content" label="短信内容" show-overflow-tooltip></el-table-column>
                <el-table-column prop="img_url[0]" label="图片地址" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status_text" label="状态" show-overflow-tooltip></el-table-column>
                <el-table-column prop="create_at" label="添加时间" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="create_at" label="审核时间" show-overflow-tooltip></el-table-column> -->
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" size="mini">编辑</el-button>
                    <!-- <el-button @click="handledetele(scope.row)" type="danger" size="mini">删除</el-button> -->
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div v-if="activeIndex == 2">
            <div style="margin-bottom: 8px">
              <el-button size="small" @click="addspClick" type="primary">添加模板</el-button>
            </div>
            <el-tabs v-model="spactiveName" type="card" @tab-click="sphandleClicks">
              <el-tab-pane label="全部" name="0"></el-tab-pane>
              <el-tab-pane label="待审核" name="1"></el-tab-pane>
              <el-tab-pane label="已通过" name="2"></el-tab-pane>
              <el-tab-pane label="已驳回" name="3"></el-tab-pane>
            </el-tabs>
            <div class="ibox-content">
              <el-table :data="tableDatasp" border style="width: 100%" v-loading="loadingsp" :height="heightsp"
                ref="configurationTable">
                <el-table-column prop="id" label="模板ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="type_text" label="短信类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sign_text" label="签名" show-overflow-tooltip></el-table-column>
                <el-table-column prop="title" label="标题" show-overflow-tooltip></el-table-column>
                <el-table-column prop="content" label="短信内容" show-overflow-tooltip></el-table-column>
                <el-table-column prop="img_url[0]" label="图片地址" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status_text" label="状态" show-overflow-tooltip></el-table-column>
                <el-table-column prop="create_at" label="添加时间" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="create_at" label="审核时间" show-overflow-tooltip></el-table-column> -->
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button @click="sphandleClick(scope.row)" type="primary" size="mini">编辑</el-button>
                    <!-- <el-button @click="handledetele(scope.row)" type="danger" size="mini">删除</el-button> -->
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <el-dialog :title="names" :visible.sync="dialogVisible" top="20px" class="tab">
          <el-divider></el-divider>
          <div class="dialog-ibox-content">
            <el-form :model="ruleForms" :rules="rules" ref="ruleForms" label-width="100px" class="demo-ruleForm">
              <el-form-item label="短信类型">
                <el-select v-model="ruleForms.lx" filterable placeholder="请选择" size="small" clearable
                  style="width: 200px">
                  <el-option v-for="item in lx_options" :key="item.id" :label="item.content_name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择签名">
                <el-select v-model="ruleForms.qm" filterable placeholder="请选择" size="small" clearable
                  style="width: 200px">
                  <el-option v-for="item in qm_options" :key="item.id" :label="item.content_name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态">
                <el-select v-model="ruleForms.zt" filterable placeholder="请选择" size="small" clearable
                  style="width: 200px">
                  <el-option v-for="item in zt_options" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="模板ID">
                <el-input v-model="ruleForms.mbid" size="small"></el-input>
              </el-form-item>
              <el-form-item label="标题">
                <el-input v-model="ruleForms.title" size="small"></el-input>
              </el-form-item>
              <el-form-item label="内容">
                <el-input v-model="ruleForms.content" size="small" type="textarea"></el-input>
              </el-form-item>
              <el-form-item label="图片:" prop="imgList" class="m-b">
                <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload" :limit="1"
                  :headers="{ token:$store.state.user.token }" :data="{ image_class_id:'72',file_type:'1'}"
                  :file-list="ruleForms.imgList" :on-success="uploadSuccess" :on-remove="uploadRmove" :before-upload="beforeAvatarUpload"
                  list-type="picture-card">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <span class="ps">只限1张哦</span>
              </el-form-item>
            </el-form>
          </div>
          <el-divider></el-divider>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            <el-button @click="getbz('ruleForms')" size="small" type="primary">提交</el-button>
          </span>
        </el-dialog>

        <el-dialog :title="namess" :visible.sync="dialogVisibles" top="20px" class="tab">
          <el-divider></el-divider>
          <div class="dialog-ibox-content">
            <el-form :model="ruleFormss" :rules="ruless" ref="ruleFormss" label-width="100px" class="demo-ruleForm">
              <el-form-item label="短信类型">
                <el-select v-model="ruleFormss.lx" filterable placeholder="请选择" size="small" clearable
                  style="width: 200px">
                  <el-option v-for="item in lx_options" :key="item.id" :label="item.content_name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择签名">
                <el-select v-model="ruleFormss.qm" filterable placeholder="请选择" size="small" clearable
                  style="width: 200px">
                  <el-option v-for="item in qm_options" :key="item.id" :label="item.content_name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态">
                <el-select v-model="ruleFormss.zt" filterable placeholder="请选择" size="small" clearable
                  style="width: 200px">
                  <el-option v-for="item in zt_options" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="模板ID">
                <el-input v-model="ruleFormss.mbid" size="small"></el-input>
              </el-form-item>
              <el-form-item label="标题">
                <el-input v-model="ruleFormss.title" size="small"></el-input>
              </el-form-item>
              <el-form-item label="内容">
                <el-input v-model="ruleFormss.content" size="small" type="textarea"></el-input>
              </el-form-item>
              <el-form-item label="图片:" prop="imgList" class="m-b">
                <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload" :limit="1"
                  :headers="{ token:$store.state.user.token }" :data="{ image_class_id:'72',file_type:'1'}"
                  :file-list="ruleFormss.imgList" :on-success="tpuploadSuccess" :on-remove="tpuploadRmove"
                  :before-upload="tpbeforeAvatarUpload" list-type="picture-card">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="视频:" prop="imgLists" class="m-b">
                <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload" :limit="1"
                  :headers="{ token:$store.state.user.token }" :data="{ image_class_id:'72',file_type:'1'}"
                  :file-list="ruleFormss.imgLists" :on-success="spuploadSuccess" :on-remove="spuploadRmove"
                  :before-upload="spbeforeAvatarUpload" list-type="picture-card">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
          <el-divider></el-divider>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibles = false" size="small">取 消</el-button>
            <el-button @click="getsp('ruleFormss')" size="small" type="primary">提交</el-button>
          </span>
        </el-dialog>
      </div>
    </el-card>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        ipAdress: "http://file.jskwsx.com:223",
        namess: "",
        dialogVisibles: false,
        spactiveName: "",
        loadingsp: false,
        tableDatasp: [],
        heightsp: null,
        names: "",
        activeIndex: "1",
        activeName: "0",
        tableData: [],
        loadings: false,
        heights: null,
        dialogVisible: false,
        lx_options: [],
        qm_options: [],
        ruleForms: {
          lx: "",
          qm: "",
          title: "",
          content: "",
          remarks: "",
          imgList: [],

          zt: "",
          mbid: "",
        },
        ruleFormss: {
          lx: "",
          qm: "",
          title: "",
          content: "",
          remarks: "",
          imgList: [],
          imgLists: [],
          zt: "",
          mbid: "",
        },
        zt_options: [{
            id: 1,
            name: "待审核",
          },
          {
            id: 2,
            name: "已通过",
          },
          {
            id: 3,
            name: "已驳回",
          },
        ],
        rules: {},
        ruless: {},
        mapListed: [],
        mapListeds: [],
        eid: "",
        eids: "",
        imgs: [],
      };
    },
    mounted() {
      // this.search()
      this.getlx();
      this.getqm();
      this.handleClicks();
    },
    methods: {
      //文字短信表格数据
      search() {
        let that = this;
        that.loadings = true;
        axios
          .post(
            "admin/pc/sendmsg/getData", {
              status: that.activeName - 0,
              source: 1,
            }, {
              token: true,
            }
          )
          .then((res) => {
            that.loadings = false;
            that.tableData = res.data.data;
          })
          .catch((error) => {});
      },
      handleClicks() {
        this.search();
      },
      //文字视频tabs
      handleSelect(key, keyPath) {
        this.activeIndex = key;
      },
      //短信类型
      getlx() {
        let that = this;
        axios
          .post(
            "admin/pc/sendmsg/RightList", {
              source: "content",
              sys_id: 10,
              title: "",
              type_id: 30,
            }, {
              token: true,
            }
          )
          .then((res) => {
            that.lx_options = res.data.data;
          })
          .catch((error) => {});
      },
      //选择签名
      getqm() {
        let that = this;
        axios
          .post(
            "admin/pc/sendmsg/RightList", {
              source: "content",
              sys_id: 10,
              title: "",
              type_id: 29,
            }, {
              token: true,
            }
          )
          .then((res) => {
            that.qm_options = res.data.data;
          })
          .catch((error) => {});
      },
      addwzClick() {
        let that = this;
        this.eid=''
        that.dialogVisible = true;
        this.mapListed = [];
        this.ruleFormss.imgLists=[]
        this.ruleFormss.imgList=[]
        this.ruleForms.imgList=[]
        that.names = "新增";
        that.ruleForms.lx = "";
        that.ruleForms.qm = "";
        that.ruleForms.zt = "";
        that.ruleForms.title = "";
        that.ruleForms.content = "";
        // that.ruleForms.remarks = ''
        that.ruleForms.file_url = "";
        that.ruleForms.mbid = "";
      },
      handleClick(row) {
        let that = this;
        this.mapListed = [];
        this.ruleFormss.imgLists=[]
        this.ruleFormss.imgList=[]
        this.ruleForms.imgList=[]
        that.dialogVisible = true;
        that.names = "编辑";
        that.eid = row.id;
        that.ruleForms.mbid = row.templateid;
        that.ruleForms.lx = row.type - 0;
        that.ruleForms.qm = row.sign - 0;
        that.ruleForms.zt = row.status;
        that.ruleForms.title = row.title;
        that.ruleForms.content = row.content;
        that.ruleForms.file_url = row.img_url[0];
        let obj = {
          url: row.img_url[0],
        };
        this.ruleForms.imgList.push(obj);
        this.mapListed.push(obj);
      },
      //新增提交
      getbz(formName) {
        let that = this;

        if (this.mapListed.length == 0) {
          that.$message({
            type: "warning",
            message: "请上传图片!",
          });
          return;
        }
        that.$refs[formName].validate((valid) => {
          if (valid) {
            axios
              .post(
                "admin/pc/sendmsg/Madd", {
                  id: that.names == "新增" ? 0 : that.eid,
                  templateid: that.ruleForms.mbid,
                  type: that.ruleForms.lx,
                  sign: that.ruleForms.qm,
                  title: that.ruleForms.title,
                  content: that.ruleForms.content,
                  img_url: [this.mapListed[0].url],
                  status: that.ruleForms.zt,
                  source: 1,
                }, {
                  token: true,
                }
              )
              .then((response) => {
                if (response.data.code == 200) {
                  that.$message({
                    type: "success",
                    message: "操作成功!",
                  });
                  this.dialogVisible = false;
                  // this.mapListed = []
                  that.search();
                } else {
                  that.$message({
                    showClose: true,
                    message: response.data.message,
                    type: "error",
                  });
                }
              })
              .catch((error) => {});
          } else {
            return false;
          }
        });
      },
      //编辑提交
      getsp(formName) {
        let that = this;
        // if(that.mapListeds.length >0){

        // }
        that.mapListeds = that.mapListeds.map((spItem) => {
          return that.ipAdress + spItem;
        });
        that.mapListed = that.mapListed.map((tpItem) => {
          return that.ipAdress + tpItem;
        });
        that.$refs[formName].validate((valid) => {
          if (valid) {
            axios
              .post(
                "admin/pc/sendmsg/Madd", {
                  id: that.namess == "新增" ? 0 : that.eids,
                  templateid: that.ruleFormss.mbid,
                  type: that.ruleFormss.lx,
                  sign: that.ruleFormss.qm,
                  title: that.ruleFormss.title,
                  content: that.ruleFormss.content,
                  img_url: that.mapListed,
                  status: that.ruleFormss.zt,
                  source: 2,
                  video_url: that.mapListeds,
                }, {
                  token: true,
                }
              )
              .then((response) => {
                if (response.data.code == 200) {
                  that.$message({
                    type: "success",
                    message: "操作成功!",
                  });
                  this.dialogVisibles = false;
                  // this.mapListed = []
                  that.searchs();
                } else {
                  that.$message({
                    showClose: true,
                    message: response.data.message,
                    type: "error",
                  });
                }
              })
              .catch((error) => {});
          } else {
            return false;
          }
        });
      },
      uploadSuccess(response, file, fileList) {
        let that = this;
        if (response.code == "201") {
          that.$nextTick(() => {
            let mainImg = that.$refs.upload;
            if (mainImg) {
              mainImg.uploadFiles.forEach((element, index) => {
                if (file.uid == element.uid) {
                  mainImg.uploadFiles.splice(index, 1);
                }
              });
            }
          });
          that.$alert(response.msg);
          return;
        }
        that.$message({
          message: "上传成功",
          type: "success",
        });
        that.mapListed.push(response.data);
      },
      uploadRmove(file, fileList) {
        this.ruleForms.imgList = [];

        this.mapListed.splice(0, 1);
      },
      beforeAvatarUpload(file) {
        const isJPG =
          file.type === "image/jpeg" ||
          file.type == "image/png" ||
          file.type == "image/gif";

        if (!isJPG) {
          this.$message({
            showClose: true,
            message: "只能是图片哦",
            type: "error",
          });
        }

        return isJPG;
      },
      //视频短信表格数据
      searchs() {
        let that = this;
        that.loadingsp = true;
        axios
          .post(
            "admin/pc/sendmsg/getData", {
              status: that.spactiveName - 0,
              source: 2,
            }, {
              token: true,
            }
          )
          .then((res) => {
            that.loadingsp = false;
            that.tableDatasp = res.data.data;
          })
          .catch((error) => {});
      },
      addspClick() {
        let that = this;
        that.dialogVisibles = true;
        that.namess = "新增";
        that.ruleFormss.lx = "";
        that.ruleFormss.qm = "";
        that.ruleFormss.zt = "";
        that.ruleFormss.title = "";
        that.ruleFormss.content = "";
        // that.ruleForms.remarks = ''
        // that.ruleFormss.file_url = ''
        that.ruleFormss.mbid = "";

        // 每次打开将视频和图片数组清空
        that.mapListeds = [];
        that.mapListed = [];
        this.ruleFormss.imgLists = [];
        this.ruleFormss.imgList = [];
      },
      sphandleClick(row) {
        let that = this;
        this.ruleFormss.imgLists = [];
        this.ruleFormss.imgList = [];
        that.mapListed = [];
        that.mapListeds = [];
        that.dialogVisibles = true;
        that.namess = "编辑";
        that.eids = row.id;
        that.ruleFormss.mbid = row.templateid;
        that.ruleFormss.lx = row.type - 0;
        that.ruleFormss.qm = row.sign - 0;
        that.ruleFormss.zt = row.status;
        that.ruleFormss.title = row.title;
        that.ruleFormss.content = row.content;
        let imgObj = Object.values(row.img_url);
        imgObj.forEach((i) => {
          let obj = {
            url: i,
          };
          this.ruleFormss.imgList.push(obj);
          this.mapListed.push(obj);
        });
        let spObj = Object.values(row.video_url);
        spObj.forEach((s) => {
          let objs = {
            url: s,
          };
          this.ruleFormss.imgLists.push(objs);
          this.mapListeds.push(objs);
        });
        // // this.mapListed = imgObj;
        // debugger;
        // // that.ruleFormss.file_url = row.img_url
        // // let obj = {
        // //     url: row.img_url
        // // }
        // // this.ruleFormss.imgList.push(obj)
        // // this.mapListed.push(obj)

        // that.ruleForms.file_url = row.img_url[0]
        // let obj = {
        //     url: row.img_url[0]
        // }
        // this.ruleForms.imgList.push(obj)
        // this.mapListed.push(obj)

        // let objs = {
        //     url: row.video_url
        // }
        // this.ruleFormss.imgLists.push(objs)
        // this.mapListeds.push(objs)
      },
      sphandleClicks() {
        this.searchs();
      },

      tpuploadSuccess(response, file, fileList) {
        let that = this;
        if (response.code == "201") {
          that.$nextTick(() => {
            let mainImg = that.$refs.upload;
            if (mainImg) {
              mainImg.uploadFiles.forEach((element, index) => {
                if (file.uid == element.uid) {
                  mainImg.uploadFiles.splice(index, 1);
                }
              });
            }
          });
          that.$alert(response.msg);
          return;
        }
        that.$message({
          message: "上传成功",
          type: "success",
        });
        that.mapListed.push(response.data);
      },
      tpuploadRmove(file, fileList) {
        this.ruleFormss.imgList = [];

        this.mapListed.splice(0, 1);
      },
      tpbeforeAvatarUpload(file) {
        const isJPG =
          file.type === "image/jpeg" ||
          file.type == "image/png" ||
          file.type == "image/gif";

        if (!isJPG) {
          this.$message({
            showClose: true,
            message: "只能是图片哦",
            type: "error",
          });
        }

        return isJPG;
      },

      spuploadSuccess(response, file, fileList) {
        let that = this;
        if (response.code == "201") {
          that.$nextTick(() => {
            let mainImg = that.$refs.upload;
            if (mainImg) {
              mainImg.uploadFiles.forEach((element, index) => {
                if (file.uid == element.uid) {
                  mainImg.uploadFiles.splice(index, 1);
                }
              });
            }
          });
          that.$alert(response.msg);
          return;
        }
        that.$message({
          message: "上传成功",
          type: "success",
        });
        that.mapListeds.push(response.data);
      },
      spuploadRmove(file, fileList) {
        this.ruleFormss.imgLists = [];

        this.mapListeds.splice(0, 1);
      },
      spbeforeAvatarUpload(file) {},
    },
  };
</script>

<style>
</style>